import React from 'react';
import ContentViewComponent from '../../../../Component/ContentViewComponent/ContentViewComponent';
import ApiHandler from '../../../../Handler/ApiHandler';
import { useNavigate } from 'react-router-dom';
import { getRoutePathname } from '../../../../Handler/RouteHandler';
import { Box, Grid2 as Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { Delete, Edit, Add } from '@mui/icons-material';
import Swal from 'sweetalert2';
import { dispatch } from '../../../../App';
import { SnackbarOpen } from '../../../../Reducer/SnackBarReducer/SnackBarSlice';

const DAYS = [
    { value: 1, label: 'Lundi' },
    { value: 2, label: 'Mardi' },
    { value: 3, label: 'Mercredi' },
    { value: 4, label: 'Jeudi' },
    { value: 5, label: 'Vendredi' },
    { value: 6, label: 'Samedi' },
    { value: 7, label: 'Dimanche' },
];

function AvailabilityCalendar() {
    const [loading, setLoading] = React.useState(true);
    const [breadcrumbs, setBreadcrumbs] = React.useState({});
    const [availabilities, setAvailabilities] = React.useState([]);
    const navigate = useNavigate();

    const loadData = () => {
        ApiHandler.get({ route: 'configuration_availability_list' }, (response) => {
            if (response.status === 200) {
                setAvailabilities(response.data ?? []);
            } else {
                dispatch(
                    SnackbarOpen({
                        text:
                            response.error && response.error.message
                                ? response.error.message
                                : "Une erreur inattendu s'est produite.",
                        variant: 'error',
                    }),
                );
            }
        });
    };

    React.useEffect(() => {
        setBreadcrumbs({
            title: 'Configuration',
            context: 'Calendrier des disponibilités',
            description: '',
            links: []
        });

        loadData();
        setTimeout(() => setLoading(false), 800);
    }, []);

    const getDaySlots = (dayOfWeek) => {
        return (availabilities || []).filter((item) => item.dayOfWeek === dayOfWeek);
    };

    const onDelete = (item) => {
        Swal.fire({
            title: "Supprimer ce créneau ?",
            text: `${item.startTime} - ${item.endTime}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#87bba4",
            cancelButtonColor: "var(--greytext)",
            confirmButtonText: "Confirmer",
            cancelButtonText: "Annuler",
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                ApiHandler.delete(
                    {
                        route: "configuration_availability_delete",
                        params: { id: item.id },
                    },
                    (response) => {
                        if (response.status === 200) {
                            dispatch(
                                SnackbarOpen({
                                    text: "Disponibilité supprimée avec succès",
                                    variant: "success",
                                }),
                            );
                            loadData();
                        } else {
                            dispatch(
                                SnackbarOpen({
                                    text:
                                        response.error && response.error.message
                                            ? response.error.message
                                            : "Une erreur inattendu s'est produite.",
                                    variant: "error",
                                }),
                            );
                        }
                    },
                );
            }
        });
    };

    return (
        <ContentViewComponent loading={loading} breadcrumbs={breadcrumbs}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6">Règles globales (semaine type)</Typography>
                <Box>
                    <Tooltip title={"Ajouter un créneau"} placement="left" arrow>
                        <IconButton onClick={() => navigate(getRoutePathname('configuration_availability', { id: 'add' }))}>
                            <Add />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>
            <Grid container spacing={2}>
                {DAYS.map((day) => {
                    const slots = getDaySlots(day.value);
                    return (
                        <Grid key={day.value} size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 3 }}>
                            <Box
                                sx={{
                                    border: '1px solid #ececec',
                                    borderRadius: '12px',
                                    backgroundColor: '#fff',
                                    minHeight: '220px',
                                    p: 1.5,
                                }}
                            >
                                <Typography sx={{ fontWeight: 700, mb: 1.5 }}>{day.label}</Typography>
                                {slots.length < 1 ? (
                                    <Typography sx={{ color: '#8a8a8a', fontSize: '13px' }}>
                                        Aucun créneau
                                    </Typography>
                                ) : (
                                    slots.map((item) => (
                                    <Box
                                        key={item.id}
                                        sx={{
                                            p: 1,
                                            mb: 1,
                                            borderRadius: '10px',
                                            border: '1px solid #e8e8e8',
                                            backgroundColor: item.isActive ? '#f7fff9' : '#ffe6e6',
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography sx={{ fontWeight: 600, fontSize: '13px' }}>
                                                {item.isActive ? `${item.startTime} - ${item.endTime}` : 'Fermé'}
                                            </Typography>
                                                <Box>
                                                    <Tooltip title={"Éditer"} placement="top" arrow>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => navigate(getRoutePathname('configuration_availability', { id: item.id }))}
                                                        >
                                                            <Edit sx={{ fontSize: 18 }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title={"Supprimer"} placement="top" arrow>
                                                        <IconButton size="small" onClick={() => onDelete(item)}>
                                                            <Delete sx={{ fontSize: 18 }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                            </Box>
                                            {!item.isActive && (
                                                <Typography sx={{ color: '#999', fontSize: '12px' }}>Jour fermé</Typography>
                                            )}
                                        </Box>
                                    ))
                                )}
                            </Box>
                        </Grid>
                    );
                })}
            </Grid>
        </ContentViewComponent>
    );
}

export default AvailabilityCalendar;
